module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("Qz4kO"))).then(() => parcelRequire('37nVf'));